export default __webpack_public_path__ + "static/media/simProfile-7.d08e1507.png";